/* eslint-disable indent */
/* eslint-disable max-len */
import React, { useCallback, useEffect,useState,useContext,useRef } from "react"
import { motion } from 'framer-motion'
import TopHeader from "../../../../components/TopHeader"
import { Link } from "react-router-dom"
import { useDispatch } from "react-redux"
import { useParams,useLocation,useNavigate,useSearchParams } from "react-router-dom"
import { useSelector} from 'react-redux'
import CustomOverLay from "../../../../components/CustomOverLay"
import GlobalContext from "../../../../components/Context/GloablContext"
import { useOnClickOutside } from "../../../../CommonMethods/OutsideClick"
import SearchEmptyScreen from "../../../../components/SearchEmptyScreen"
import formatMobileNumber from "../../../../CommonMethods/FormatMobileNumber"
import { useViewOrganizationUserQuery } from "../../../../features/organizationUserSlice"
import SubDivsionList from "./Components"
import { convertEpochToDateFormat } from "../../../../CommonMethods/DateConversion"
import { handleViewUserScreen } from "../../../../redux/systemConfigSlice"
import { handleEditMessageSent } from "../../../../redux/systemConfigSlice"
import ImportHistoryTable from "../../../ManageAdminAndCoporateUser/ImportHistoryTable/ImportHistory"
import HelpGuideModal from "../../../../components/HelpGuideModal"
import {useGetHelpGuideAdminQuery} from '../../../../features/patientSlice'
import OtpPreferenceList from "../../../../components/OtpPreferenceList/OtpPreferenceList"
import { resetProviderSearch } from "../../../../redux/providerSearchSlice"

export default function ViewOrganizationUser(){
    const navigate=useNavigate()
    const {isSideBar,sendMessageToStartEditing,editSocket,setToastErrorMessage,setIsAdvancedSearchOpen} = useContext(GlobalContext)
    const location=useLocation();
    const messageSent = useSelector(state=>state?.systemConfigData?.messageSent)
    const dispatch=useDispatch()
    const auth=useSelector(state=>state?.auth)
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const viewId=useSelector(state=>state?.systemConfigData?.viewToUser)
    const [isChangeStatusOPen,setIsChangeStatusOpen]=useState(false)
    const outSideClick = useRef();
    const [viewOrgUser,setViewOrgUser]=useState('')
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    
    const {id}=useParams()

    const viewData=useViewOrganizationUserQuery(`${id}?action=view`,{refetchOnMountOrArgChange: true})
   
    useEffect(()=>{
    
        if(viewData!==undefined){
            setViewOrgUser(viewData)
          dispatch(handleViewUserScreen([id,viewData?.data?.data[0]?._id]))
        }
      },[viewData])


      useEffect(() => {
        if (userType === 'corporate-user') {
            setQueryParamsadmin('type=admin-view-org-user');
        } else {
            setQueryParamsadmin('type=admin-view-org-user');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);

    const ref=useRef()
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })
    useOnClickOutside(ref, () => {
        setIsChangeStatusOpen(false)
    })
    const handleEditButtonClick = () =>{
        if(!messageSent){
            sendMessageToStartEditing(viewData?.data?.data[0]?.user_id)
            let message
            editSocket.onmessage = (event) =>{
                message = event.data
                if(JSON.parse(message)?.success_status===true && JSON.parse(message)?.message==='Success'){
                    navigate(`/manage-organizations/manage-organization-users/edit-organization-user/${id}`,{state:[location.state,true,id]})
                    handleSearchClose()
                } else{
                    dispatch(handleEditMessageSent(false))
                    { (JSON.parse(message)?.adminId) &&
                        setToastErrorMessage(`A user with username ${decodeURIComponent( JSON.parse(message)?.adminId)} is already editing this organization user`)
                    }
                   
                }
            }    
        }
    }   
    const date=convertEpochToDateFormat(viewData?.data?.data[0]?.created_at,dateformat)

    const handleSearchClose = () => {
        dispatch(resetProviderSearch()),
        setIsAdvancedSearchOpen(false)         
    }

    const handleGoBackToOrgList = (e) => {
        e.preventDefault();
        dispatch(resetProviderSearch());
        setIsAdvancedSearchOpen(false);
        navigate("/manage-organizations/manage-organization-users", { state: Array.isArray(location.state) ? '' : location.state });
    };

    return(
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Manage Organization User"}/>
                {viewData?.isFetching&&viewData?.status!=="fulfilled"?<CustomOverLay Active text="Loading Organization User Details..." classKey={`absolute top-0 left-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar?'opened-sidebar-config':'system_config_overlay'}`}/>:status==="rejected"?<SearchEmptyScreen text={"No data found"} />:<>

                    <div className='bg-white rounded-lg py-[14px] h-customh3'>
                        <motion.div 
                            className="mt-1"
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{duration:0.5}}
                        >
                            <div className='bg-white'>
                                <div className="px-[30px]">
                                    <div className='flex items-center mb-[32px]'>
                                        <h1
                                            className="text-sm font-normal text-[#52555D] cursor-pointer"
                                            onClick={handleGoBackToOrgList}
        >
                                            List of Organizations
                                        </h1>

                                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                        <Link to={`/manage-organizations/${viewId}`}
                                            onClick={handleSearchClose}
                                        >
                                            <h1 className="text-sm font-normal text-[#52555D]">View Organization</h1>
                                        </Link>
                                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                        <Link to="/manage-organizations/manage-organization-users" state={Array.isArray(location.state)?'':location.state}>
                                            <h1 className="text-sm font-normal text-[#52555D]">List Organization Users</h1>
                                        </Link>
                                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                        <h1 className="text-sm font-normal text-[#008586]">View Organization User</h1>
                                        {
                                            userType !=='super-admin' &&
                                            <span   onClick={() => setHelpGuideModel(true)} className='ml-auto min-w-fit cursor-pointer'>
                                                <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                                            </span> 
                                        }
                                    </div>
                                    <div className="flex items-center pb-3 xl:justify-start justify-between">
                                        <Link to={'/manage-organizations/manage-organization-users'} state={Array.isArray(location.state)?'':location.state} className='flex items-center min-w-max z-10'>
                                            <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                            <span className='text-sm font-normal text-[#008586] ml-3'>Go back to Listing</span>
                                        </Link>
                                        <h1 className='text-xl font-normal text-[#000000] text-center w-full xl:-ml-[146px]'>
                                            View Organization User
                                        </h1>
                                        <div className="xl:hidden block mr-7">
                                            <button type="button" 
                                                onClick={()=>{handleEditButtonClick()}}
                                                id="edit" className={`min-w-max px-4 py-2 border border-[#972E4C] h-fit rounded-[16px] flex items-center ml-4`}>
                                                <span className='w-5'><img src="/images/edit_icon.svg" alt="icon"/></span>
                                                <span className='pl-2.5 text-lg font-normal text-[#972E4C]'>Edit</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="pl-[30px] pr-4">
                                    <div className="flex justify-between items-center pl-[30px] pr-11">
                                        <div className="flex items-center">
                                            <p className="text-xl font-semibold text-[#000000]">{viewData?.data?.data[0]?.first_name} {viewData?.data?.data[0]?.last_name}</p>
                                            <p className="text-sm font-normal text-[#000000] px-5">{viewData?.data?.data[0]?.user_id}</p>
                                            {viewData?.data?.data[0]?.status=='inactive' ? <p className="px-3 py-1.5 bg-[#C5C9DA] rounded-[16px] text-sm font-semibold text-[#52555D]">Inactive</p> : 
                                            <p className="px-3 py-1.5 bg-[#CCE7E7] rounded-[16px] text-sm font-semibold text-[#006A6B]">Active</p>
                                                }
                                        </div>
                                        <div className="flex items-center">
                                            <button type='button'
                                                onClick={()=>{
                                                    navigate('/manage-organizations/manage-organization-user/activity_history',{state:[viewData?.data?.data[0]?.user_name,viewData?.data?.data[0]?._id]})
                                                    handleSearchClose()
                                                }}
                                                id="view_activity_log"
                                                className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] rounded-[16px] ml-2.5
                            bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88] `} style={{'width':'max-content'}}>
                                                <span>View Activity Log</span> 
                                            </button>
                                            <div className="xl:block hidden">
                                                <button type="button" 
                                                    onClick={()=>{handleEditButtonClick()}} 
                                                    id="edit" className={`min-w-max px-4 py-2 border border-[#972E4C] h-fit rounded-[16px] flex items-center ml-4`}>
                                                    <span className='w-5'><img src="/images/edit_icon.svg" alt="icon"/></span>
                                                    <span className='pl-2.5 text-lg font-normal text-[#972E4C]'>Edit</span>
                                                </button>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    <div className="h-customh9 overflow-auto scrollbar_purple pr-2.5 mt-4">
                                        <div className="w-full px-6">
                                            <div className="bg-[#E7EAF4] rounded-lg p-6">
                                                <div className="flex -mx-1 flex-wrap">
                                                    <div className="w-1/3 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Username</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {viewData?.data?.data[0]?.user_name}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/3 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Email Address</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {viewData?.data?.data[0]?.email_address}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/3 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Mobile Number</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {viewData?.data?.data[0]?.mobile_number!==""?viewData?.data?.data[0]?.mobile_country_code+" "+formatMobileNumber(viewData?.data?.data[0]?.mobile_number):"-"}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/3 px-1">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Main Number</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {viewData?.data?.data[0]?.main_country_code!==""?viewData?.data?.data[0]?.main_country_code+' '+formatMobileNumber(viewData?.data?.data[0]?.main_number):"-"} 
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/3 px-1">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Permission Access</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {viewData?.data?.data[0]?.permission_access==='user'?'User':'Admin'}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="xl:w-1/4 w-1/3 px-1">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Created Date</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {date}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* otp list */}
                                            <OtpPreferenceList
                                                username={viewData?.data?.data[0]?.user_name}
                />
                                            {viewData?.data?.data[0]?.user_id && (
                                                <ImportHistoryTable userId={viewData?.data?.data[0]?.user_id} />
                                            )}
                                            <SubDivsionList 
                                                id={id}
                                                user_id={viewData?.data?.data[0]?.user_id}
                                            />

                                        </div>
                                        {/* <SubDivtable viewOrganizationUserInfo={viewOrganizationUserInfo}/> */}
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </>}
                {(helpGuideModel && helpguidestatus==="fulfilled") &&
                <HelpGuideModal
                    setHelpGuideModel={setHelpGuideModel}
                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
            />
            }
            </div>
        </>
    )
}